import { ThemeColors, ThemeColorsConfig } from '@genai/chatbot-ai';

const spherePrimaryThemePalette = {
    'gc-primary-color-light-text': '',
    'gc-primary-color-dark-text': '',
    'gc-primary-color-palette-50': '#eff8e5',
    'gc-primary-color-palette-100': '#d7ecbd',
    'gc-primary-color-palette-200': '#bcdf92',
    'gc-primary-color-palette-300': '#a0d264',
    'gc-primary-color-palette-400': '#89c93e',
    'gc-primary-color-palette-500': '#73bf00',
    'gc-primary-color-palette-600': '#63af00',
    'gc-primary-color-palette-700': '#4d9c00',
    'gc-primary-color-palette-800': '#358800',
    'gc-primary-color-palette-900': '#006700',
    'gc-primary-color-palette-A100': '',
    'gc-primary-color-palette-A200': '',
    'gc-primary-color-palette-A400': '',
    'gc-primary-color-palette-A700': '',
    'gc-primary-color-palette-50-text': '',
    'gc-primary-color-palette-100-text': '',
    'gc-primary-color-palette-200-text': '',
    'gc-primary-color-palette-300-text': '',
    'gc-primary-color-palette-400-text': '',
    'gc-primary-color-palette-500-text': '',
    'gc-primary-color-palette-600-text': '',
    'gc-primary-color-palette-700-text': '',
    'gc-primary-color-palette-800-text': '',
    'gc-primary-color-palette-900-text': '',
    'gc-primary-color-palette-A100-text': '',
    'gc-primary-color-palette-A200-text': '',
    'gc-primary-color-palette-A400-text': '',
    'gc-primary-color-palette-A700-text': ''
};

const sphereAccentThemePalette = {
    'gc-accent-color-light-text': '',
    'gc-accent-color-dark-text': '',
    'gc-accent-color-palette-50': '#eff5e9',
    'gc-accent-color-palette-100': '#d7e5c8',
    'gc-accent-color-palette-200': '#bdd4a6',
    'gc-accent-color-palette-300': '#a4c485',
    'gc-accent-color-palette-400': '#92b86c',
    'gc-accent-color-palette-500': '#7fad51',
    'gc-accent-color-palette-600': '#719e49',
    'gc-accent-color-palette-700': '#5f8b3f',
    'gc-accent-color-palette-800': '#4e7735',
    'gc-accent-color-palette-900': '#2f5623',
    'gc-accent-color-palette-A100': '',
    'gc-accent-color-palette-A200': '',
    'gc-accent-color-palette-A400': '',
    'gc-accent-color-palette-A700': '',
    'gc-accent-color-palette-50-text': '',
    'gc-accent-color-palette-100-text': '',
    'gc-accent-color-palette-200-text': '',
    'gc-accent-color-palette-300-text': '',
    'gc-accent-color-palette-400-text': '',
    'gc-accent-color-palette-500-text': '',
    'gc-accent-color-palette-600-text': '',
    'gc-accent-color-palette-700-text': '',
    'gc-accent-color-palette-800-text': '',
    'gc-accent-color-palette-900-text': '',
    'gc-accent-color-palette-A100-text': '',
    'gc-accent-color-palette-A200-text': '',
    'gc-accent-color-palette-A400-text': '',
    'gc-accent-color-palette-A700-text': ''
};

const sphereWarnThemePalette = {
    'gc-warn-color-light-text': '',
    'gc-warn-color-dark-text': '',
    'gc-warn-color-palette-50': '#ffecee',
    'gc-warn-color-palette-100': '#ffcfd2',
    'gc-warn-color-palette-200': '#fa9c98',
    'gc-warn-color-palette-300': '#f47570',
    'gc-warn-color-palette-400': '#ff5549',
    'gc-warn-color-palette-500': '#ff4429',
    'gc-warn-color-palette-600': '#f63b2b',
    'gc-warn-color-palette-700': '#e42f25',
    'gc-warn-color-palette-800': '#d7271d',
    'gc-warn-color-palette-900': '#c71a0f',
    'gc-warn-color-palette-A100': '',
    'gc-warn-color-palette-A200': '',
    'gc-warn-color-palette-A400': '',
    'gc-warn-color-palette-A700': '',
    'gc-warn-color-palette-50-text': '',
    'gc-warn-color-palette-100-text': '',
    'gc-warn-color-palette-200-text': '',
    'gc-warn-color-palette-300-text': '',
    'gc-warn-color-palette-400-text': '',
    'gc-warn-color-palette-500-text': '',
    'gc-warn-color-palette-600-text': '',
    'gc-warn-color-palette-700-text': '',
    'gc-warn-color-palette-800-text': '',
    'gc-warn-color-palette-900-text': '',
    'gc-warn-color-palette-A100-text': '',
    'gc-warn-color-palette-A200-text': '',
    'gc-warn-color-palette-A400-text': '',
    'gc-warn-color-palette-A700-text': ''
};

const darkThemeColors: ThemeColors = {
    chat: {
        'chat-bg-color': '#303030'
    },
    messages: {
        'chat-message-current-user-bg-color': '#1c1c1c'
    },
    messageInput: {
        'chat-prompt-bg-color': '',
        'chat-prompt-text-color': '',
        'chat-prompt-input-bg-color': '',
        'chat-prompt-hints-active-bg-color': '',
        'chat-prompt-hints-active-icon-color': '',
        'chat-prompt-hints-active-icon-hover-color': '',
        'chat-prompt-hints-item-bg-color': '',
        'chat-prompt-hints-item-text-color': 'rgb(207, 235, 189)',
        'chat-prompt-hints-item-hover-bg-color': '#364d2b',
        'chat-prompt-hints-item-hover-text-color': 'rgb(207, 235, 189)'
    },
    historyPanel: {
        'chat-history-panel-bg-color': '#262626',
        'chat-history-panel-header-bg-color': '#171914'
    },
    configPanel: {},
    hallucination: {},
    pluginReferences: {},
    rating: {},
    disconnect: {},
    portable: {},
    newChatDialog: {}
};

export const sphereChatbotThemeConfig: ThemeColorsConfig = {
    // palette: {
    //     primary: spherePrimaryThemePalette,
    //     accent: sphereAccentThemePalette,
    //     warn: sphereWarnThemePalette
    // },
    dark: darkThemeColors
};
